import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

// Add new catalogue/SKU
export const addCatalogueApi = async (catalogueData, authHeaders) => {
    try {
        const payload = {
            apiVerb: 'POST',
            ...catalogueData
        };
        const res = await apiCallPost(apiPaths.getModels, payload, authHeaders);
        if (res) {
            return { data: res, status: true }
        }
        return { data: {}, status: false, errMsg: 'Failed to add catalogue' };
    } catch (err) {
        return { status: false, errMsg: err.message }
    }
}

// Update existing catalogue/SKU
export const updateCatalogueApi = async (catalogueData, authHeaders) => {
    try {
        const payload = {
            apiVerb: 'UPDATE',
            ...catalogueData
        };
        const res = await apiCallPost(apiPaths.getModels, payload, authHeaders);
        if (res) {
            return { data: res, status: true }
        }
        return { data: {}, status: false, errMsg: 'Failed to update catalogue' };
    } catch (err) {
        return { status: false, errMsg: err.message }
    }
}

// Delete catalogue/SKU
export const deleteCatalogueApi = async (catalogueId, authHeaders) => {
    try {
        const payload = {
            apiVerb: 'DELETE',
            id: catalogueId
        };
        const res = await apiCallPost(apiPaths.getModels, payload, authHeaders);
        if (res) {
            return { data: res, status: true }
        }
        return { data: {}, status: false, errMsg: 'Failed to delete catalogue' };
    } catch (err) {
        return { status: false, errMsg: err.message }
    }
}
